// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3QXE_","amount":"Amount_amount__1CDon","tip":"Amount_tip__1sBE-","tipHeader":"Amount_tipHeader__3m9fT","tipsWrap":"Amount_tipsWrap__bqxMK"};